import { DashboardMenu } from "@whitespace/components";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

import usePages from "../../../../../../plugins/@whitespace/gatsby-theme-wordpress-basic/src/hooks/pages";
import { getPage } from "../../../../../../plugins/@whitespace/gatsby-theme-wordpress-basic/src/utils/pageTree";
import ModuleWrapper from "../ModuleWrapper";

import * as defaultStyles from "./MenuModule.module.css";

MenuModule.propTypes = {
  className: PropTypes.string,
  module: PropTypes.shape({
    menu: PropTypes.shape({ contacts: PropTypes.array }),
  }),
  styles: PropTypes.objectOf(PropTypes.string),
  title: PropTypes.node,
  transformMenuItem: PropTypes.func,
};

function defaultTransformMenuItem(menuItem, { pages }) {
  let { connectedNode, label, description, url, target, extra, ...rest } =
    menuItem;

  let icon = extra?.icon || rest?.icon;
  if (typeof icon === "string") {
    icon = { name: icon };
  }

  let { contentType: { node: { name: type = "custom" } = {} } = {}, id } =
    connectedNode?.node || {};

  let content = type === "page" ? getPage(pages, id) : {};

  return {
    type,
    url,
    target: connectedNode?.node?.id ? target : "_blank",
    ...content,
    label,
    description: description || (content && content.description),
    ...extra,
    ...rest,
    icon,
  };
}

export default function MenuModule({
  className,
  module = {},
  styles = defaultStyles,
  title,
  transformMenuItem = defaultTransformMenuItem,
  ...restProps
}) {
  const pages = usePages();
  const { menu } = module;

  let menuItems = menu?.node?.menuItems?.nodes?.map((node) =>
    transformMenuItem(node, { pages }),
  );

  return (
    <ModuleWrapper
      title={title}
      {...restProps}
      className={clsx(styles.component, className)}
    >
      <DashboardMenu items={menuItems} />
    </ModuleWrapper>
  );
}
